import axiosInstance from '../../utils/axiosConfig';

// Action Types
export const GET_ALL_FORMS = 'GET_ALL_FORMS';
export const GET_FORM_BY_ID = 'GET_FORM_BY_ID';
export const CREATE_FORM = 'CREATE_FORM';
export const UPDATE_FORM_BY_ID = 'UPDATE_FORM_BY_ID';
export const DELETE_FORM_BY_ID = 'DELETE_FORM_BY_ID';
export const CREATE_LIST_FORM = 'CREATE_LIST_FORM';
export const FORM_ERROR = 'FORM_ERROR';

const API_URL = process.env.REACT_APP_BACKEND_URL_MS_INVESTIGATION;

export const getAllForms = () => async dispatch => {
    try {
        const res = await axiosInstance.get(`${API_URL}/form`);
        dispatch({ type: GET_ALL_FORMS, payload: res.data });
    } catch (err) {
        dispatch({ type: FORM_ERROR, payload: err.response.data });
    }
};

export const getFormById = (id) => async dispatch => {
    try {
        const res = await axiosInstance.get(`${API_URL}/form/${id}`);
        dispatch({ type: GET_FORM_BY_ID, payload: res.data });
    } catch (err) {
        dispatch({ type: FORM_ERROR, payload: err.response.data });
    }
};

export const createForm = (formData) => async dispatch => {
    try {
        const res = await axiosInstance.post(`${API_URL}/form`, formData);
        dispatch({ type: CREATE_FORM, payload: res.data });
    } catch (err) {
        dispatch({ type: FORM_ERROR, payload: err.response.data });
    }
};

export const createListForm = (formsData) => async dispatch => {
    try {
        const res = await axiosInstance.post(`${API_URL}/listForm`, formsData);
        dispatch({ type: CREATE_LIST_FORM, payload: res.data });
    } catch (err) {
        dispatch({ type: FORM_ERROR, payload: err.response.data });
    }
};

export const updateFormById = (id, formData) => async dispatch => {
    try {
        const res = await axiosInstance.put(`${API_URL}/form/${id}`, formData);
        dispatch({ type: UPDATE_FORM_BY_ID, payload: res.data });
    } catch (err) {
        dispatch({ type: FORM_ERROR, payload: err.response.data });
    }
};

export const deleteFormById = (id) => async dispatch => {
    try {
        await axiosInstance.delete(`${API_URL}/form/${id}`);
        dispatch({ type: DELETE_FORM_BY_ID, payload: id });
    } catch (err) {
        dispatch({ type: FORM_ERROR, payload: err.response.data });
    }
};
